module.exports = __webpack_public_path__ + "img/104.4.b6605387.png";